<style scoped lang="scss">
  .top-tabs{
    background: rgba(0,0,0,.6);
    position: absolute;
    bottom:0;
    left:0;
    right:0;
    z-index: 3;
    ul{
      display: flex;
      padding:0 10%;
      flex-wrap: wrap;
      height:60px;
      overflow-y: hidden;
      li{
        min-width:140px;
        font-size: 16px;
        color:#fff;
        height:60px;
        line-height: 60px;
        padding:0 15px;
        cursor: pointer;
        text-align: center;
        white-space: nowrap;
        &.active{
          background: #fff;
          color:#333;
        }
      }
    }
  }
</style>
<style scoped>
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (min-width: 300px) and (max-width:400px)
{
  .top-tabs .container ul li{
    margin-right: auto!important;
    width: 90px!important;
    margin-left: auto!important;
  }
  .top-tabs ul li.active{
    padding-left: 10px;
  }
}
@media screen and (max-width: 640px){
  .container{
    width: 100% !important;

  }
  .container li{
    font-size: 12px!important;
  }
  .top-tabs ul{
    height: 40px!important;
  }
  .top-tabs ul li{
    min-width: 65px!important;
    height: 40px!important;
    line-height: 40px!important;
  }

}
</style>
<template>
  <div class="top-tabs">
    <div class="container">
      <ul>
        <li v-for="(item, index) in menuLists" :class="{active: currentTab === index}" :key="index" @click="getLists(item.id, index)">{{item.name}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'qk-top-tabs',
  props: {
    menuLists: {
      type: Array
    }
  },
  data () {
    return {
      currentTab: this.$route.query.current ? parseInt(this.$route.query.current) : 0
    }
  },
  methods: {
    getLists (id, index) {
      this.currentTab = index
      this.$emit('getLists', id)
    }
  },
  watch: {
    $route (to) {
      this.currentTab = parseInt(to.query.current)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/topTabs.vue